<div class="breadcrumb-container">
  <div class="row">
    <div class="col-lg-12">
      <h1>Annotations</h1>
      <ol class="breadcrumb" id="breadcrumbNav">
        <li>
          <a [routerLink]="['/home']">
            <i class="fa fa-home"></i>
            <span>ProManual </span>
          </a>
        </li>
        <li class="active">
          <i class="fa fa-envelope"></i>
          <span>Annotations</span>
        </li>
      </ol>
    </div>
  </div>
</div>

<div class="component-container" style="height: 90%; margin-bottom: 25px">
  <div class="component-content col-lg-4">
    <div class="association-list">
      <div class="panel panel-success" style="padding-bottom: 60px">
        <div class="panel-heading">
          <h4>
            <span>Documents with Open Annotations</span>
            <span class="badge pull-right">{{ documents.length }}</span>
          </h4>
        </div>
        <div class="panel-body panel-list">
          <div class="list-group">
            <div
              class="list-group-item"
              (click)="filterTo(d)"
              [class.list-group-item-success]="d.Id == document.Id"
              *ngFor="let d of documents"
            >
              <h5>{{ d.FileName }}</h5>
              {{ d.ProductName }}
              <span class="badge pull-right"
                >{{ d.Annotations.Data.length }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="component-content col-lg-8">
    <div class="association-list">
      <div class="panel panel-success" style="padding-bottom: 60px">
        <div class="panel-heading">
          <h4>
            <span>Annotations &bull; </span>
            <strong
              >{{ filtered ? document.FileName : 'All Documents' }}</strong
            >
            <span
              class="badge pull-right"
              data-bind="text: (activeDocument() === null ? annotations().length : activeDocument().Annotations().length)"
            ></span>
          </h4>
        </div>
        <div class="panel-body panel-list">
          <div class="row">
            <div class="col-lg-12">
              <!-- IMPORTANT:  This item is duplicated, for filtered vs !filtered -->
              <ul class="media-list">
                <li
                  class="media"
                  (click)="showDetails(annot)"
                  *ngFor="let annot of (filtered ? document.Annotations.Data : annotations)"
                  style="border: 1px solid #dddddd"
                >
                  <div class="pull-left" *ngIf="!annot.IsPDF">
                    <img
                      class="media-object"
                      alt="annotation"
                      width="170"
                      height="90"
                      src="api/Manuals/AnnotationImage?annotationId={{ annot.Id }}"
                    />
                  </div>
                  <div class="pull-left" *ngIf="annot.IsPDF">
                    <i class="fa fa-file-pdf-o fa-4x" aria-hidden="true"></i>
                  </div>
                  <div class="media-body">
                    <h5 class="media-heading">
                      {{ annot.Document?.ProductName }}
                      <button
                        *ngIf="annot.IsPDF"
                        class="btn btn-xs btn-info pull-right"
                        [class.disabled]="isDownloadingPDF"
                        (click)="openAnnotationPDF(annot); $event.stopPropagation()"
                        style="margin-left: 10px"
                        title="Open Annotation PDF"
                      >
                        <span *ngIf="!isDownloadingPDF">
                          <i class="fa fa-external-link"></i>
                        </span>
                        <span *ngIf="isDownloadingPDF">
                          <i class="fa fa-spinner fa-spin"></i>
                        </span>
                      </button>
                      <a
                        *ngIf="!annot.IsPDF"
                        class="btn btn-xs btn-info pull-right"
                        style="margin-left: 10px"
                        title="Open Annotation Image"
                        href="api/Manuals/AnnotationImage?annotationId={{ annotation.Id }}"
                        target="_blank"
                      >
                        <span *ngIf="!isDownloadingPDF">
                          <i class="fa fa-external-link"></i>
                        </span>
                        <span *ngIf="isDownloadingPDF">
                          <i class="fa fa-spinner fa-spin"></i>
                        </span>
                      </a>
                    </h5>
                    <p data-bind="text: Note"></p>
                    <small class="pull-right">
                      {{ annot.Submitted | amDateFormat: 'MM/DD/YYYY' }} {{
                      annot.Submitted | amDateFormat: 'hh:mm A' }} by {{
                      annot.User.FirstName }} {{ annot.User.LastName }}
                    </small>
                    Note: {{ annot.Note }}
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  bsModal
  #annotationDetails="bs-modal"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog" style="width: 1000px">
    <div class="modal-content" data-bind="with: entity">
      <div class="modal-header">
        <button
          type="button"
          class="close"
          (click)="close()"
          data-dismiss="modal"
          aria-hidden="true"
        >
          &times;
        </button>
        <h4 class="modal-title" id="myModalLabel">
          Annotation Details &bull; {{ annotation.Submitted | amDateFormat:
          'MM/DD/YYYY' }} {{ annotation.Submitted | amDateFormat: 'hh:mm A' }}
        </h4>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-lg-6">
            <span>File name </span>
            <i class="fa fa-ellipsis-v"></i>
            {{ annotation.Document?.FileName }}
          </div>
          <div class="col-lg-6">
            <span>Product Name </span>
            <i class="fa fa-ellipsis-v"></i>
            {{ annotation.Document?.ProductName }}
          </div>
        </div>
        <div class="row" *ngIf="annotation.Id && !annotation.IsPDF">
          <div class="col-lg-12 bg-info">
            <iframe
              width="100%"
              height="640"
              [src]="sanitizedImageUrl"
              frameborder="0"
              style="border: none"
            ></iframe>
          </div>
        </div>

        <div id="pdfPreviewPane" class="row">
          <div
            class="row"
            style="min-height: 200px; position: relative; max-height: 60vh"
          >
            <div *ngIf="pdfSrc && !downloadingDocument" class="col-lg-12">
              <pdf-viewer
                [src]="pdfSrc"
                [render-text]="true"
                [show-all]="true"
                [autoresize]="true"
                (after-load-complete)="onLoadPDF($event)"
                (error)="onPDFLoadError($event)"
                (on-progress)="onPDFLoadProgress($event)"
                style="
                  display: block;
                  min-height: 80vh;
                  width: 100%;
                  background-color: grey;
                  border: 1px solid grey;
                "
              ></pdf-viewer>
            </div>
            <div
              class="col-sm-6"
              *ngIf="annotation.IsPDF && !pdfSrc && !downloadingDocument"
              style="
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
              "
            >
              <div style="width: 100%; text-align: center">
                <span>Error Downloading Survey Document</span>
              </div>
            </div>
            <div
              class="col-sm-6"
              *ngIf="downloadingDocument"
              style="
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
              "
            >
              <div style="width: 100%; text-align: center">
                <span>Downloading Document ...</span>
                <i class="fa fa-spinner fa-spin fa-pulse fa-2x"></i>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <span>Notes from </span>
            {{ annotation.User.FirstName }} {{ annotation.User.LastName }}
            <i class="fa fa-ellipsis-v"></i>
            {{ annotation.Note }}
          </div>
        </div>
      </div>
      <div style="display: flex; justify-content: space-between; padding: 1rem">
        <div style="display: flex; align-items: center; gap: 10px">
          <button
            class="btn btn-info"
            [class.disabled]="isDownloadingManualPDF"
            (click)="downloadManualPDF(annotation.Document); $event.stopPropagation()"
            style="margin-left: 10px"
            title="Download PDF"
          >
            <span *ngIf="!isDownloadingManualPDF"> Download Manual </span>
            <span *ngIf="isDownloadingManualPDF">
              <i class="fa fa-spinner fa-spin"></i>
            </span>
          </button>
          <a
            class="btn btn-info"
            [class.disabled]="isDownloadingManualPDF"
            (click)="openManualPDF(annotation.Document)"
            style="cursor: pointer"
          >
            <span *ngIf="!isDownloadingManualPDF"
              >Open Manual PDF <i class="fa fa-external-link"></i
            ></span>
            <span *ngIf="isDownloadingManualPDF">
              <i class="fa fa-spinner fa-spin"></i> Opening...
            </span>
          </a>
        </div>
        <div style="display: flex; align-items: center; gap: 10px">
          <a
            *ngIf="!annotation.IsPDF"
            class="btn btn-info"
            href="api/Manuals/AnnotationImage?annotationId={{ annotation.Id }}"
            target="_blank"
            style="cursor: pointer"
            ><span *ngIf="!isDownloadingPDF"
              >Open Image <i class="fa fa-external-link"></i></span
          ></a>
          <button
            *ngIf="annotation.IsPDF"
            class="btn btn-xs btn-info pull-right"
            [class.disabled]="isDownloadingPDF"
            (click)="downloadAnnotationPDF(annotation); $event.stopPropagation()"
            style="margin-left: 10px"
            title="Download PDF"
          >
            <span *ngIf="!isDownloadingPDF">
              Download <i class="fa fa-file-pdf-o"></i>
            </span>
            <span *ngIf="isDownloadingPDF">
              <i class="fa fa-spinner fa-spin"></i>
            </span>
          </button>
          <a
            *ngIf="annotation.IsPDF"
            class="btn btn-info"
            [class.disabled]="isDownloadingPDF"
            (click)="openAnnotationPDF(annotation)"
            style="cursor: pointer"
          >
            <span *ngIf="!isDownloadingPDF"
              >Open PDF <i class="fa fa-external-link"></i
            ></span>
            <span *ngIf="isDownloadingPDF">
              <i class="fa fa-spinner fa-spin"></i> Opening...
            </span>
          </a>
          <button type="button" class="btn btn-default" (click)="close()">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  bsModal
  #errModal="bs-modal"
  class="modal fade"
  [config]="{ keyboard: false, backdrop: 'static' }"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="myModalLabel">{{ errModalTitle }}</h4>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-lg-12">{{ errModalMsg }}</div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-warning" (click)="closeErrModal()">
          Close
        </button>
      </div>
    </div>
  </div>
</div>
